import React from "react";

function CheckboxAnswers({ questionId, answers, onChange }) {
  return (
    <div className="checkbox-answers">
      {answers.map((answer) => (
        <div key={answer.id} className={`check answer-option${answer.checked ? " checked" : ""}`}>
          <input
            type="checkbox"
            name={questionId}
            value={answer.id}
            id={`answer-${answer.id}`}
            checked={!!answer.checked}
            onChange={() => onChange(questionId, answer.id, "check")}
          />
          <label className="answer-option-check-box" htmlFor={`answer-${answer.id}`}>
            {answer.text}
          </label>
        </div>
      ))}
    </div>
  );
}

export default CheckboxAnswers;
